import { Link } from "react-router-dom";
import { movies } from "@/mocks/movies";
import MovieCard from "@/components/base/MovieCard";
import SectionHeading from "@/components/base/SectionHeading";

const hot = [...movies].sort((a, b) => b.views - a.views).slice(0, 6);

export default function HotMovies() {
  return (
    <section className="w-full px-4 md:px-8 mt-12 md:mt-16">
      <SectionHeading
        title="热播精选"
        subtitle="近期讨论度最高的剧集与电影，按热度排序"
        moreTo="/category/tv"
        moreLabel="更多剧集"
      />
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
        {hot.map((m) => (
          <MovieCard key={m.id} movie={m} />
        ))}
      </div>
    </section>
  );
}